import React from 'react';
import { getRouterAdapter } from '../utils';

type UseNestedAbsoluteRouteParams = {
  element: React.JSX.Element;
  base: string;
  path: string;
  condition?: boolean;
};

/**
 * Lets you create a nested route with a RR-5-style absolute path that still works in
 * RR-6's world of relative paths in nested routs.
 *
 * @deprecated Use `Route` instead and make your route composition work with relative paths!
 */
export const useNestedAbsoluteRoute = ({
  base,
  path,
  element,
  condition = true,
}: UseNestedAbsoluteRouteParams) => {
  const { Route, useMatch } = getRouterAdapter();
  const match = useMatch({ path: base, end: false });

  if (condition && match) {
    // ast-grep-ignore
    return <Route path={path} element={element} />;
  }

  return null;
};
